import { jsx } from "react/jsx-runtime";
import React from "react";
import cx from "classnames";
const SSRIcon = (props) => {
  const {
    prefix = "",
    viewBox = "0 0 24 24",
    paths,
    className,
    modifier,
    ariaHidden = true,
    ...otherProps
  } = props;
  const cssStyles = cx(
    `${prefix}svg-icon`,
    className,
    modifier && `${prefix}svg-icon--${modifier}`
  );
  return paths ? /* @__PURE__ */ jsx(
    "svg",
    {
      focusable: "false",
      viewBox,
      width: "24",
      height: "24",
      ...otherProps,
      className: cssStyles,
      "aria-hidden": ariaHidden,
      children: paths().map((path, id) => {
        return React.cloneElement(path, { key: id });
      })
    }
  ) : null;
};
var SSRIcon_default = SSRIcon;
export {
  SSRIcon_default as default
};
